// Custom Shop the Look interactions
// - Desktop: hover dot shows card
// - Mobile/touch: tap dot toggles card, tap elsewhere closes
// - Edge detection: flips card to the left side if it would overflow the right edge

(function () {
  function init() {
    var wraps = document.querySelectorAll('.cs-stl-image-wrap');

    wraps.forEach(function (wrap) {
      var dots = wrap.querySelectorAll('.cs-stl-dot');
      var cards = wrap.querySelectorAll('.cs-stl-card');

      dots.forEach(function (dot, index) {
        var card = cards[index];
        if (!card) return;

        function openCard() {
          // Close any other open cards within this wrap
          cards.forEach(function (c, i) {
            if (c !== card) {
              c.classList.remove('is-visible');
              dots[i].setAttribute('aria-expanded', 'false');
              dots[i].classList.remove('is-active');
            }
          });

          positionCard(card, dot, wrap);
          card.classList.add('is-visible');
          dot.setAttribute('aria-expanded', 'true');
          dot.classList.add('is-active');
        }

        function closeCard() {
          card.classList.remove('is-visible');
          dot.setAttribute('aria-expanded', 'false');
          dot.classList.remove('is-active');
        }

        // Desktop hover
        dot.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) {
            openCard();
          }
        });

        wrap.addEventListener('mouseleave', function (e) {
          if (window.matchMedia('(hover: hover)').matches) {
            // Only close if leaving both dot and card area
            if (!card.contains(e.relatedTarget) && !dot.contains(e.relatedTarget)) {
              closeCard();
            }
          }
        });

        card.addEventListener('mouseleave', function () {
          if (window.matchMedia('(hover: hover)').matches) {
            closeCard();
          }
        });

        // Tap / click (works on both touch and desktop as fallback)
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var isOpen = card.classList.contains('is-visible');
          if (isOpen) {
            closeCard();
          } else {
            openCard();
          }
        });
      });
    });

    // Tap outside to close any open cards
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.cs-stl-image-wrap')) {
        document.querySelectorAll('.cs-stl-card.is-visible').forEach(function (c) {
          c.classList.remove('is-visible');
        });
        document.querySelectorAll('.cs-stl-dot.is-active').forEach(function (d) {
          d.classList.remove('is-active');
          d.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Click-and-drag horizontal scrolling (desktop) + progress bar
    document.querySelectorAll('.cs-stl-scroll').forEach(function (scroller) {
      var isDown = false;
      var startX = 0;
      var scrollLeftStart = 0;
      var moved = false;

      var section = scroller.closest('.cs-stl-section');
      var progressBar = section ? section.querySelector('.cs-stl-progress-bar') : null;

      function updateProgress() {
        if (!progressBar) return;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll <= 0) {
          progressBar.style.width = '100%';
          progressBar.style.left = '0%';
          return;
        }
        var ratio = scroller.scrollLeft / maxScroll;
        var visibleRatio = scroller.clientWidth / scroller.scrollWidth;
        var barWidth = visibleRatio * 100;
        var barLeft = ratio * (100 - barWidth);
        progressBar.style.width = barWidth + '%';
        progressBar.style.left = barLeft + '%';
      }

      scroller.addEventListener('scroll', updateProgress);
      window.addEventListener('resize', updateProgress);
      updateProgress();

      scroller.addEventListener('mousedown', function (e) {
        isDown = true;
        moved = false;
        scroller.classList.add('is-dragging');
        startX = e.pageX;
        scrollLeftStart = scroller.scrollLeft;
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-dragging');
      });

      window.addEventListener('mouseleave', function () {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-dragging');
      });

      scroller.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 5) moved = true;
        scroller.scrollLeft = scrollLeftStart - dx;
      });

      // Prevent dot clicks from registering as a "click" right after a drag
      scroller.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
    });
  }

  // Edge detection: flips card horizontally/vertically if it would overflow the image bounds
  function positionCard(card, dot, wrap) {
    // Reset flip classes first to measure natural position
    card.classList.remove('cs-stl-card--left', 'cs-stl-card--top', 'cs-stl-card--bottom');

    // Skip on mobile where card is centered via CSS
    if (window.innerWidth <= 768) return;

    var wrapRect = wrap.getBoundingClientRect();
    var dotRect = dot.getBoundingClientRect();
    var cardWidth = card.offsetWidth || 280;
    var cardHeight = card.offsetHeight || 280;

    // Horizontal check
    var dotLeftWithinWrap = dotRect.left - wrapRect.left;
    var spaceToRight = wrapRect.width - dotLeftWithinWrap;

    if (spaceToRight < (cardWidth + 30)) {
      card.classList.add('cs-stl-card--left');
    }

    // Vertical check - card is normally centered on the dot (translateY(-50%))
    var dotCenterY = dotRect.top + (dotRect.height / 2);
    var halfCard = cardHeight / 2;

    var spaceAbove = dotCenterY - wrapRect.top;
    var spaceBelow = wrapRect.bottom - dotCenterY;

    if (spaceBelow < halfCard && spaceAbove >= cardHeight) {
      // Not enough room below: anchor card's bottom to the dot
      card.classList.add('cs-stl-card--top');
    } else if (spaceAbove < halfCard && spaceBelow >= cardHeight) {
      // Not enough room above: anchor card's top to the dot
      card.classList.add('cs-stl-card--bottom');
    } else if (spaceAbove < halfCard && spaceBelow < halfCard) {
      // Tight both ways: just anchor to whichever side has more room
      if (spaceBelow >= spaceAbove) {
        card.classList.add('cs-stl-card--bottom');
      } else {
        card.classList.add('cs-stl-card--top');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();